/* HZ 2026-09-14: moved out of snippets/hz-exit-intent.liquid into this deferred asset file.
   Same code; it used to be inlined into every page (and, for the quick-add,
   once per product card) and blocked HTML parsing while it evaluated. */
(function() {
  'use strict';

  /* --- Double-init guard — prevent duplicate listeners if snippet renders twice --- */
  if (window.hzExitIntentLoaded) return;
  window.hzExitIntentLoaded = true;

  /* --- Checkout / cart / account page guard — never init on these paths --- */
  var _path = window.location.pathname.toLowerCase();
  if (_path.startsWith('/checkout') ||
      _path.startsWith('/cart') ||
      _path.startsWith('/account') ||
      _path.startsWith('/a/')) {
    return;
  }

  /* --- Config --- */
  var COOKIE_NAME   = 'hz_popup_shown';
  var COOKIE_DAYS   = 30;
  var SESSION_KEY   = 'hz_popup_session';
  var ARM_DELAY_MS  = 10000;  /* desktop exit intent arm delay */
  var TIMER_DELAY_MS = 15000; /* mobile timer delay */
  var EXCLUDED_PATHS = ['/cart', '/checkout', '/account', '/a/'];
  var KLAVIYO_COMPANY_ID = 'UrbNzQ';
  var KLAVIYO_LIST_ID    = 'SKZrBC';
  /* WELCOME10 (Shopify, read 2026-11-03): 10% off all items, no minimum, once per customer, combines with nothing */
  var WELCOME_CODE       = 'WELCOME10';

  /* --- Elements --- */
  var modal      = document.getElementById('hz-exit');
  if (!modal) return;
  var panel      = modal.querySelector('.hz-exit__panel');
  var overlay    = modal.querySelector('.hz-exit__overlay');
  var closeBtn   = document.getElementById('hz-exit-close');
  var emailInput = document.getElementById('hz-exit-email');
  var consentBox = document.getElementById('hz-exit-consent');
  var ctaBtn     = document.getElementById('hz-exit-cta');
  var declineBtn = document.getElementById('hz-exit-decline');
  var errorEl    = document.getElementById('hz-exit-error');
  var formEl     = document.getElementById('hz-exit-form');
  var successEl  = document.getElementById('hz-exit-success');
  var announceEl = document.getElementById('hz-exit-announce');

  /* --- Helpers --- */
  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 86400000);
    document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax;Secure';
  }

  function isExcludedPage() {
    var path = window.location.pathname.toLowerCase();
    for (var i = 0; i < EXCLUDED_PATHS.length; i++) {
      if (path.indexOf(EXCLUDED_PATHS[i]) === 0) return true;
    }
    return false;
  }

  function isShownEl(el) {
    if (!el) return false;
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  /* HZ 2026-11-03: the live banner is Shopify's own (#shopify-pc__banner); hz-consent-banner is the
     legacy custom one (not rendered today). If Shopify will show a banner that has not been injected yet,
     wait for it too. */
  function isConsentBannerVisible() {
    var legacy = document.getElementById('hz-consent-banner');
    if (legacy && legacy.classList.contains('hz-consent-visible')) return true;
    var pc = document.getElementById('shopify-pc__banner');
    if (pc) return isShownEl(pc);
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    try {
      return !!(cp && cp.shouldShowBanner && cp.shouldShowBanner() &&
        cp.getTrackingConsent && cp.getTrackingConsent() === 'no_interaction');
    } catch (e) { return false; }
  }

  /* HZ 2026-11-03: never cover an open cart (HZ drawer, Dawn drawer, Dawn add-to-cart notification) */
  function isCartOpen() {
    if (document.querySelector('#hzCartDrawer.hz-cart-drawer--open, .hz-cart-drawer--open, cart-drawer.active')) return true;
    return isDawnCartNotificationVisible();
  }

  function isLoggedIn() {
    return !!(window.__st && window.__st.cid);
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function isDesktop() {
    return window.matchMedia && window.matchMedia('(pointer: fine)').matches;
  }

  /* --- Should Show --- */
  function shouldShow() {
    if (getCookie(COOKIE_NAME)) return false;
    if (sessionStorage.getItem(SESSION_KEY)) return false;
    if (isExcludedPage()) return false;
    if (isLoggedIn()) return false;
    return true;
  }

  if (!shouldShow()) return;

  /* --- Trigger type tracking --- */
  var _triggerType = 'unknown';
  var _shown = false;
  var _lastFocus = null;

  /* --- Show / Hide --- */
  function isDawnCartNotificationVisible() {
    /* Dawn sets aria-hidden="false" on <cart-notification> only when actively showing.
       The element lives in DOM at all times — computed style checks produce false positives
       because Dawn hides it via transform/transition, not display:none or visibility:hidden. */
    var el = document.querySelector('cart-notification');
    return !!(el && el.getAttribute('aria-hidden') === 'false');
  }

  /* HZ 2026-11-03: a timer/scroll trigger that lands while the cookie banner or the cart is open is
     kept, not dropped: it fires 2 s after both are gone (EU visitors see it after Accept/Decline). */
  /* M2: polling is capped at 60 s. After that, it re-arms only on an event: a click inside the
     cookie banner, Shopify's visitorConsentCollected, or the HZ drawer closing. */
  var _pending = null;
  var _pendTimer = null;
  var PEND_MAX_TICKS = 60;
  function deferShow(triggerType) {
    if (_pending) return;
    _pending = triggerType;
    var clearTicks = 0;
    var ticks = 0;
    _pendTimer = setInterval(function() {
      ticks++;
      if (_shown || !shouldShow()) { clearInterval(_pendTimer); _pending = null; return; }
      clearTicks = (isConsentBannerVisible() || isCartOpen()) ? 0 : clearTicks + 1;
      if (clearTicks >= 2) {
        clearInterval(_pendTimer);
        var t = _pending; _pending = null;
        show(t);
      } else if (ticks >= PEND_MAX_TICKS) {
        clearInterval(_pendTimer);
        var t2 = _pending; _pending = null;
        rearmOnEvent(t2);
      }
    }, 1000);
  }
  function rearmOnEvent(triggerType) {
    var fired = false;
    function go() {
      if (fired) return;
      fired = true;
      document.removeEventListener('click', onClick, true);
      document.removeEventListener('visitorConsentCollected', go);
      if (drawerObs) drawerObs.disconnect();
      deferShow(triggerType);
    }
    function onClick(e) { if (e.target.closest && e.target.closest('#shopify-pc__banner')) go(); }
    document.addEventListener('click', onClick, true);
    document.addEventListener('visitorConsentCollected', go);
    var drawerEl = document.getElementById('hzCartDrawer');
    var drawerObs = null;
    if (drawerEl && window.MutationObserver) {
      drawerObs = new MutationObserver(function() { if (!isCartOpen()) go(); });
      drawerObs.observe(drawerEl, { attributes: true, attributeFilter: ['class'] });
    }
  }

  function show(triggerType) {
    if (_shown) return;
    if (!shouldShow()) return;
    if (isConsentBannerVisible() || isCartOpen()) {
      if (triggerType !== 'exit-intent') deferShow(triggerType);
      return;
    }

    _triggerType = triggerType || 'unknown';
    _shown = true;

    /* Move to body — prevents Shopify section wrapper inert trap */
    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }
    _lastFocus = document.activeElement;
    modal.setAttribute('aria-hidden', 'false');
    modal.inert = false;
    document.body.style.overflow = 'hidden';
    setTimeout(function() { emailInput.focus(); }, 300);

    /* Suppress for rest of session */
    setCookie(COOKIE_NAME, '1', COOKIE_DAYS);
    sessionStorage.setItem(SESSION_KEY, '1');

    /* Clean up all triggers */
    document.documentElement.removeEventListener('mouseleave', onMouseLeave);
    window.removeEventListener('scroll', onScroll);
  }

  function hide() {
    modal.setAttribute('aria-hidden', 'true');
    modal.inert = true;
    document.body.style.overflow = '';
    if (_lastFocus) { _lastFocus.focus(); _lastFocus = null; }
  }

  /* --- Desktop: Exit Intent (pointer: fine only) --- */
  function onMouseLeave(e) {
    if (e.clientY > 0) return;
    show('exit-intent');
  }

  if (isDesktop()) {
    setTimeout(function() {
      if (!shouldShow()) return;
      document.documentElement.addEventListener('mouseleave', onMouseLeave);
    }, ARM_DELAY_MS);
  }

  /* --- Mobile: Timer trigger (non-desktop devices) --- */
  if (!isDesktop()) {
    setTimeout(function() {
      show('timer');
    }, TIMER_DELAY_MS);
  }

  /* --- Scroll trigger: 50% depth (all devices, whichever fires first) --- */
  var _scrollArmed = false;
  function onScroll() {
    if (_scrollArmed) return;
    if (_shown || _pending) return;
    var scrolled = (window.scrollY + window.innerHeight) / document.body.scrollHeight;
    if (scrolled >= 0.5) {
      _scrollArmed = true;
      show('scroll');
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  /* --- Form Submission --- */
  function showError(msg) {
    errorEl.textContent = msg;
    errorEl.style.display = 'block';
  }

  function clearError() {
    errorEl.style.display = 'none';
    errorEl.textContent = '';
    emailInput.classList.remove('hz-exit__email--error');
  }

  function showSuccess() {
    var codeSlot = document.getElementById('hz-exit-code');
    if (codeSlot) codeSlot.textContent = WELCOME_CODE;
    formEl.style.display = 'none';
    successEl.style.display = 'block';
    if (announceEl) announceEl.textContent = 'Signed up. Your 10% off code is WELCOME10.';
    var copyBtn = document.getElementById('hz-exit-copy');
    if (copyBtn) setTimeout(function() { copyBtn.focus(); }, 50);
  }

  /* HZ 2026-11-03: copy WELCOME10 */
  function copyCode() {
    var codeEl = document.getElementById('hz-exit-code');
    var btn = document.getElementById('hz-exit-copy');
    if (!codeEl || !btn) return;
    var code = codeEl.textContent.trim();
    function done(ok) {
      btn.textContent = ok ? 'COPIED' : 'COPY';
      if (announceEl) announceEl.textContent = ok ? 'Code ' + code + ' copied.' : 'Select the code to copy it.';
      if (ok) setTimeout(function() { btn.textContent = 'COPY'; }, 2500);
    }
    function fallback() {
      var range = document.createRange();
      range.selectNodeContents(codeEl);
      var sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
      done(ok);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(function() { done(true); }, fallback);
    } else {
      fallback();
    }
  }

  function submitEmail() {
    var email = emailInput.value.trim();
    clearError();

    if (!email || !isValidEmail(email)) {
      emailInput.classList.add('hz-exit__email--error');
      showError('Please enter a valid email address.');
      emailInput.focus();
      return;
    }

    if (!consentBox.checked) {
      showError('Please agree to receive marketing emails.');
      consentBox.focus();
      return;
    }

    ctaBtn.disabled = true;
    ctaBtn.textContent = 'ONE SEC...';

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Email Popup - Welcome 10%',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: {
                  'Signup Source': _triggerType + '-popup',
                  'GDPR Consent': 'yes',
                  'Consent Timestamp': new Date().toISOString()
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: { type: 'list', id: KLAVIYO_LIST_ID }
          }
        }
      }
    };

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2025-01-15'
      },
      body: JSON.stringify(payload)
    })
    .then(function(r) {
      /* HZ 2026-11-03: only a confirmed subscribe (2xx, normally 202) gets the code */
      if (!r.ok) throw new Error('subscribe ' + r.status);
      if (window._learnq) {
        window._learnq.push(['identify', { '$email': email, '$consent': ['email'] }]);
      }
      showSuccess();
    })
    .catch(function() {
      /* failed or blocked: keep the form, let the shopper retry */
      ctaBtn.disabled = false;
      ctaBtn.textContent = 'TRY AGAIN';
      showError("That didn't go through. Please try again in a moment.");
      if (announceEl) announceEl.textContent = 'Sign up failed. Please try again.';
    });
  }

  /* --- Event Listeners --- */
  ctaBtn.addEventListener('click', submitEmail);

  emailInput.addEventListener('keydown', function(e) {
    if (e.key === 'Enter') { e.preventDefault(); submitEmail(); }
    clearError();
  });

  closeBtn.addEventListener('click', hide);
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) hide();
  });
  declineBtn.addEventListener('click', hide);
  var copyBtnEl = document.getElementById('hz-exit-copy');
  if (copyBtnEl) copyBtnEl.addEventListener('click', copyCode);

  /* HZ 2026-11-03: if a cart drawer opens while the popup is up, step aside */
  var hzDrawer = document.getElementById('hzCartDrawer');
  if (hzDrawer && window.MutationObserver) {
    new MutationObserver(function() {
      if (modal.getAttribute('aria-hidden') === 'false' && isCartOpen()) hide();
    }).observe(hzDrawer, { attributes: true, attributeFilter: ['class'] });
  }

  /* ESC close + Tab focus trap */
  document.addEventListener('keydown', function(e) {
    if (modal.getAttribute('aria-hidden') !== 'false') return;
    if (e.key === 'Escape') { hide(); return; }
    if (e.key === 'Tab') {
      var focusable = panel.querySelectorAll(
        'button:not([disabled]), a[href], input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (focusable.length === 0) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
  });
})();
